module.exports = __webpack_public_path__ + "img/holiday_select.3a5b653c.png";